<template>
  <wp-items-list
    content-type="research-articles"
    content-type-singular="research-article"
    content-name="Research articles"
    content-name-singular="Research article"
  />
</template>

<script>
import WpItemsList from '@/views/wp-item/wp-items-list/WpItemsList.vue'

export default {
  components: {
    WpItemsList,
  },
}
</script>

<style scoped>

</style>
